import { FlexGrid, Card, Box, Paragraph, Spacer } from '@telus-uds/components-web'
import Heading from 'src/siteBuilder/blocks/core/Heading/Heading'
import { TopCardWrapper } from './styles'

import BBImage from '../../Image'
import useBBViewport from 'src/hooks/useBBViewport'
import type { Asset } from 'contentful'

type BannerProps = {
  isArticlePage?: boolean
  image: Asset
  imageMobile: Asset
}

type TopCardProps = {
  title: string
  description: string
  hasCard?: boolean
}

export type HeroBannerProps = {
  image: Asset
  imageMobile?: Asset
  title?: string
  description?: string
  hasCard?: boolean
  isArticlePage?: boolean
}

const Banner = ({ image, imageMobile, isArticlePage }: BannerProps) => {
  const viewport = useBBViewport()

  const src = isArticlePage || viewport !== 'xs' ? `${image?.fields?.file?.url}` : `${imageMobile?.fields?.file?.url}`

  return (
    <>
      <Box space={viewport === 'xs' ? 0 : 5}>
        <FlexGrid gutter={!isArticlePage}>
          <FlexGrid.Row>
            {viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
              <BBImage
                priority
                src={src}
                alt={image?.fields?.description}
                width={image?.fields?.file?.details?.image?.width}
                height={image?.fields?.file?.details?.image?.height}
                rounded={isArticlePage ? 'corners' : undefined}
                placeholder="blur"
                blurDataURL={src}
              />
            ) : (
              <FlexGrid.Col xs={0} md={12}>
                <BBImage
                  priority
                  futureImage
                  styles={{ objectFit: 'cover' }}
                  src={`${image?.fields?.file?.url}`}
                  alt={image?.fields?.description || image?.fields?.title}
                  width={1170}
                  height={400}
                  placeholder="blur"
                  blurDataURL={`${image?.fields?.file?.url}`}
                />
              </FlexGrid.Col>
            )}
          </FlexGrid.Row>
        </FlexGrid>
      </Box>
    </>
  )
}

const TopCard = ({ hasCard, title, description }: TopCardProps) => (
  <FlexGrid>
    <FlexGrid.Row>
      <FlexGrid.Col md={8} lg={6} xl={5} mdOffset={3} lgOffset={5} xlOffset={6}>
        {hasCard && (
          <Card>
            <Box>
              <Heading heading="h1" size="h1" text={title} />
              <Paragraph>{description}</Paragraph>
            </Box>
          </Card>
        )}
      </FlexGrid.Col>
    </FlexGrid.Row>
  </FlexGrid>
)

const HeroBanner = ({
  title = '',
  description = '',
  hasCard = true,
  isArticlePage = false,
  image,
  imageMobile,
}: HeroBannerProps) => {
  return (
    <div data-testid="hero-banner-wrapper">
      <Banner image={image} imageMobile={imageMobile} isArticlePage={isArticlePage} />
      {hasCard && (
        <TopCardWrapper>
          <TopCard hasCard={hasCard} title={title} description={description} />
          <Spacer desktop={15} mobile={0} />
        </TopCardWrapper>
      )}
    </div>
  )
}

export default HeroBanner
